import { Component } from '@verndale/core'
import { isFocusable, keyCode } from '../../helpers'
import { gsap } from 'gsap'

class Module extends Component {
  setupDefaults() {
    this.handleEscape = this.handleEscape.bind(this);
    this.handleFocus = this.handleFocus.bind(this);

    this.ignoreUtilFocusChanges = false;

    this.dom = {
      html: document.querySelector('html'),
      body: document.querySelector('body'),
      pageContainer: document.querySelector('.page-container'),
      stickyMenu: this.el.querySelector('.header__sticky'),
      drawer: this.el.querySelector('.language-menu'),
      trigger: this.el.querySelector('.header__language-toggle'),
      triggerIconOpen: this.el.querySelector('.header__language-toggle-icon-open'),
      triggerIconClose: this.el.querySelector('.header__language-toggle-icon-close')
    };
  }

  addEventListeners() {
    document.addEventListener('keyup', this.handleEscape);
    document.addEventListener('focus', this.handleFocus, true);
    document.addEventListener('click', this.handleClickOutside.bind(this));
  }

  removeEventListeners() {
    document.removeEventListener('keyup', this.handleEscape);
    document.removeEventListener('focus', this.handleFocus, true);
  }

  toggleDrawer() {
    if (this.el.classList.contains('header--language-menu-open')) {
      this.closeDrawer();
      document.dispatchEvent(new Event('menuClose'));
    } else {
      this.openDrawer();
    }
  }

  openDrawer() {
    const tl = gsap.timeline();
    const { innerHeight, scrollY } = window;
    const { offsetTop } = this.dom.pageContainer;
    const headerHeight = this.dom.stickyMenu.offsetHeight;
    const difference = offsetTop - scrollY;
    const isTabletLandscape = window.matchMedia('(min-width: 1024px)');

    if (!isTabletLandscape.matches) this.dom.html.classList.add('is-scroll-locked');

    gsap.to(this.dom.triggerIconOpen, {
      opacity: 0,
      duration: 0.3,
      onComplete: () => {
        gsap.to(this.dom.triggerIconOpen, { display: 'none' });
        gsap.to(this.dom.triggerIconClose, { display: 'flex' });
        gsap.to(this.dom.triggerIconClose, {
          opacity: 1,
          duration: 0.3
        })
      }
    });

    this.el.classList.add('header--language-menu-open');
    tl.set(this.dom.drawer, {
      height: 0,
      autoAlpha: 1
    });
    tl.to(this.dom.drawer, {
      height: (isTabletLandscape.matches ? 'auto' : `${innerHeight - headerHeight - (difference > 0 ? difference : 0)}px`),
      duration: 0.4
    });

    this.addEventListeners();
  }

  closeDrawer() {
    const tl = gsap.timeline();
    this.el.classList.remove('header--language-menu-open');
    gsap.to(this.dom.triggerIconClose, {
      opacity: 0,
      duration: 0.3,
      onComplete: () => {
        gsap.to(this.dom.triggerIconClose, { display: 'none' });
        gsap.to(this.dom.triggerIconOpen, { display: 'flex' });
        gsap.to(this.dom.triggerIconOpen, {
          opacity: 1,
          duration: 0.3
        })
      }
    });

    tl.to(this.dom.drawer, {
      height: 0,
      padding: 0,
      duration: 0.4
    });
    tl.set(this.dom.drawer, { height: null, padding: '', autoAlpha: 0 });

    this.removeEventListeners();
  }

  handleClickOutside(e) {
    if (!this.dom.drawer.contains(e.target) && (!this.dom.trigger.contains(e.target))){
      this.closeDrawer();
    }
  }

  focusFirstDescendant(element) {
    for (let i = 0; i < element.childNodes.length; i++) {
      const child = element.childNodes[i];
      if (this.attemptFocus(child) || this.focusFirstDescendant(child)) {
        return true;
      }
    }
    return false;
  }

  focusLastDescendant(element) {
    for (let i = element.childNodes.length - 1; i >= 0; i--) {
      const child = element.childNodes[i];
      if (this.attemptFocus(child) || this.focusLastDescendant(child)) {
        return true;
      }
    }
    return false;
  }

  handleEscape(e) {
    const key = e.which || e.keyCode;

    if (key === keyCode.ESC) {
      e.stopPropagation();
      this.closeDrawer();
    }
  }

  handleFocus(e) {
    if (
      this.ignoreUtilFocusChanges ||
      e.target.classList.contains('header__language-toggle') ||
      e.target.classList.contains('header__hamburger-menu-toggle') ||
      e.target.classList.contains('header__search-toggle')
    )
      return;

    if (this.dom.drawer.contains(e.target)) {
      this.lastFocus = e.target;
    } else {
      this.focusFirstDescendant(this.dom.drawer);

      if (this.lastFocus === document.activeElement) {
        this.focusLastDescendant(this.dom.drawer);
      }
      this.lastFocus = document.activeElement;
    }
  }

  attemptFocus(element) {
    if (!isFocusable(element)) {
      return false;
    }

    this.ignoreUtilFocusChanges = true;
    try {
      element.focus();
    } catch (e) {
      return;
    }
    this.ignoreUtilFocusChanges = false;
    return document.activeElement === element;
  }
}

export default Module;
